<template>
  <b-container class="wrap-content-archive">
    <b-row class="box-head">
      <b-col
        cols="12"
        md="8"
        class="box-breadcrumb"
      >
        <b-breadcrumb :items="breadcrumbs" />
      </b-col>
      <b-col
        cols="12"
        md="4"
        class="box-back-btn"
      >
        <button @click.prevent="goBack()">
          Back to News
        </button>
      </b-col>
    </b-row>

    <div
      v-for="(content, i) in dataContent"
      :key="i"
      class="box-media"
    >
      <b-carousel
        :interval="0"
        no-animation
        indicators
      >
        <b-carousel-slide>
          <template v-slot:img>
            <img
              :src="`${baseURL}/storage/app/img/archive/${content.image}`"
              class="w-100"
            >
          </template>
        </b-carousel-slide>

        <b-carousel-slide>
          <template v-slot:img>
            <iframe
              :src="`https://www.youtube.com/embed/${content.youtube_link}`"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </template>
        </b-carousel-slide>
      </b-carousel>
    </div>

    <div
      v-for="(contest, i) in dataContent"
      :key="i"
      class="box-dec"
    >
      <Dec
        name="AWARD"
        :data="contest.level"
      />
      <Dec
        name="SUB-CATEGORY"
        :data="contest.category[0].category[0].subtitle"
      />
      <Dec
        name="ENTRY TITLE"
        :data="contest.name"
      />
      <Dec
        name="BRAND"
        :data="contest.brand"
      />
      <Dec
        name="ADVERTISER"
        :data="contest.advertiser"
      />
      <Dec
        name="ADVERTISING AGENCY"
        :data="contest.agency"
      />
    </div>

    <div class="box-suggest">
      <h1>Suggest</h1>

      <b-row>
        <b-col
          cols="12"
          md="4"
          class="col"
        >
          <img src="">
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

const Dec = () => import('./Parts/Dec')

export default {
  components: {
    Dec
  },

  data () {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          to: {
            name: 'home'
          }
        },
        {
          text: 'Archive',
          to: {
            name: 'archive'
          }
        },
        {
          text: '',
          to: {
            name: 'archive'
          }
        },
        {
          text: ''
        }
      ],
      title: '',
      dataContent: []
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      archivesList: state => state.archive.archivesList
    })
  },

  methods: {
    matchData (id) {
      if (this.archivesList) {
        const data = this.archivesList.filter(list =>
        // eslint-disable-next-line
          list.id == id
        )

        this.dataContent = data
      }
    },

    checkBreadCrumbs (data) {
      data.forEach(item => {
        this.breadcrumbs[2].text = item.category[0].name
        this.breadcrumbs[3].text = item.name
      })
    },

    goBack () {
      this.$router.go(-1)
    }
  },

  created () {
    const cateId = this.$route.params.cateId
    const id = this.$route.params.id

    if (!this.archivesList) {
      this.$store.dispatch('archive/getList', cateId)
    } else {
      this.matchData(id)
    }
  },

  watch: {
    archivesList (data) {
      const id = this.$route.params.id

      this.matchData(id)
    },

    dataContent (data) {
      this.checkBreadCrumbs(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-content-archive {
  .box-head {
    padding: 22px 0;
    border-bottom: 1px solid #CCC;

    .box-breadcrumb {
      display: flex;
      align-items: center;

      .breadcrumb {
        margin: 0;
        padding: 0;
        background: none;

        li {
          font-size: 1.25rem;

          a {
            color: black;
          }
        }
      }
    }

    .box-back-btn {
      margin-top: 22px;

      @media only screen and (min-width: $break-m) {
        margin-top: 0;
      }

      button {
        width: 100%;
        background-color: #CCC;
        padding: 12px 0;
        font-size: 1.25rem;
      }
    }
  }

  .box-media {
    padding: 22px 0;

    iframe {
      width: 100%;
      height: 29vh;
      border: none;

      @media only screen and (min-width: 767px) {
        height: 38vh;
      }

      @media only screen and (min-width: 1024px) {
        height: 59vh;
      }
    }
  }

  .box-dec {
    padding: 12px 0;
    border-top: 1px solid #CCC;
    border-bottom: 10px solid #CCC;
  }

  .box-suggest {
    padding: 22px;

    h1 {
      text-align: center;
    }

    .row {
      margin-top: 22px;

      .col {
        img {
          width: 100%;
          height: 300px;
          background-color: $light;
        }
      }
    }
  }
}
</style>
